import React from 'react';
import styles from '../../../styles/TaskDetails.module.css';
import EmptyState from '../../UI/EmptyState';

interface User {
  id: string;
  first_name: string;
  last_name: string;
  name: string;
  username: string;
  email: string;
  full_name?: string;
}

interface Approver {
  id: string;
  user: User;
}

interface TaskApproversProps {
  approvers: Approver[];
}

const TaskApprovers: React.FC<TaskApproversProps> = ({ approvers }) => {
  const hasApprovers = approvers && Array.isArray(approvers) && approvers.length > 0;
  
  const title = 'Approvers';
  const emptyMessage = 'No approvers assigned for this task.';
  
  if (!hasApprovers) {
    return (
      <div className={styles.userAssignmentInfo}>
        <div className={styles.userAssignmentHeader}>
          <div className={styles.userAssignmentTitle}>{title}</div>
        </div>
        <EmptyState
          title={title}
          description={emptyMessage}
        />
      </div>
    );
  }

  return (
    <div className={styles.userAssignmentInfo} style={{marginTop: '1rem'}}>
      <div className={styles.userAssignmentHeader}>
        <div className={styles.userAssignmentTitle} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <svg 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            style={{ color: '#f59e0b', flexShrink: 0 }}
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22,4 12,14.01 9,11.01"></polyline>
          </svg>
          <span>{title}</span>
        </div>
      </div>
      
      <div className={styles.assigneeList}>
        {approvers.map((approver: Approver) => {
          const user = approver.user;
          const firstName = user?.first_name || '';
          const lastName = user?.last_name || '';
          const email = user?.email || '';
          const fullName = user?.full_name || (firstName && lastName ? `${firstName} ${lastName}` : '');
          
          return (
            <div key={approver.id} className={styles.assigneeItem}>
              <div className={styles.assigneeAvatar} style={{ backgroundColor: '#f59e0b' }}>
                {firstName?.[0]?.toUpperCase() || email?.[0]?.toUpperCase() || 'A'}
              </div>
              <div className={styles.assigneeInfo}>
                <div className={styles.assigneeName}>
                  {fullName || email || 'Unknown Approver'}
                  <span style={{ 
                    marginLeft: '8px', 
                    fontSize: '12px', 
                    color: '#f59e0b',
                    fontWeight: 600
                  }}>(Approver)</span>
                </div>
                {email && (
                  <div className={styles.assigneeRole}>{email}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TaskApprovers;

